import { jsx as _jsx } from "preact/jsx-runtime";
import { useMessage } from '@genericBookings/context/Message';
import FormNotices from '@widgets/shared/components/FormNotices';
import StyledForm from '@bookingForm/styles/form';
function Messages() {
    const { messages, removeMessage } = useMessage();
    if (messages.length === 0) {
        return null;
    }
    return (_jsx(StyledForm.Notices, { children: messages.map(({ text, type, closable, duration, }, idx) => (_jsx(FormNotices, { message: text, type: type, closable: closable, closeTimer: duration, handleClose: () => removeMessage(idx) }))) }));
}
export default Messages;
